import React from 'react';
import { CTAButton } from './CTAButton';
export function PricingSection() {
  return <section id="comprar" className="py-12 md:py-24 bg-navy-900 relative overflow-hidden" data-id="element-72">
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1567899378494-47b22a2ae96a?q=80&w=2070&auto=format&fit=crop')] bg-cover bg-center opacity-5 mix-blend-luminosity" data-id="element-73"></div>

      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-74">
        <div className="bg-navy-950 rounded-3xl border-2 border-gold-500/50 shadow-[0_0_50px_rgba(212,168,67,0.15)] overflow-hidden" data-id="element-75">
          <div className="p-6 md:p-12 bg-gradient-to-b from-navy-950 to-navy-900 text-center" data-id="element-76">
            <div className="mb-6 md:mb-8" data-id="element-77">
              <p className="text-slate-400 text-base md:text-lg line-through mb-1 md:mb-2" data-id="element-78">
                Precio regular: $89.900
              </p>
              <div className="flex items-center justify-center gap-3 md:gap-4" data-id="element-79">
                <span className="text-4xl md:text-7xl font-heading font-black text-white" data-id="element-80">
                  $19.900
                </span>
                <span className="text-xs md:text-sm text-left text-slate-400 leading-tight" data-id="element-81">
                  Pago
                  <br data-id="element-82" />
                  Único
                </span>
              </div>
            </div>

            <CTAButton isMain={true} className="w-full md:w-auto md:px-16 md:py-6 text-lg md:text-2xl" data-id="element-83" />

            <p className="text-slate-500 text-xs md:text-sm mt-4 md:mt-6 flex items-center justify-center gap-2" data-id="element-84">
              🔒 Pago 100% seguro y encriptado
            </p>
          </div>
        </div>
      </div>
    </section>;
}